module.exports = __webpack_public_path__ + "img/login-l.efa934df.png";